import React from "react";

import { Backdrop, CircularProgress } from "@mui/material";

import logoImage from "../../assets/logos/logo.png";
import { defaultDomains } from "../../constants";
import { useGetCurrentBrandingQuery } from "../../features/branding/brandingApiSlice";

const FullLoadingScreen = () => {
	const domain = window.location.hostname;
	const { data } = useGetCurrentBrandingQuery();

	return (
		<div>
			<Backdrop
				open
				sx={{
					background: defaultDomains.includes(domain) ? "#084170" : "#fff",
					color: "#fff",
					zIndex: (theme) => theme.zIndex.drawer + 1,
					display: "flex",
					flexDirection: "column",
					gap: "20px",
				}}
			>
				<div>
					{defaultDomains.includes(domain) && (
						<img src={logoImage} alt="CargoSeller" width="542" />
					)}
					{!defaultDomains.includes(domain) && data?.logo && (
						<img src={data.logo} alt="Logo" width="542" />
					)}
				</div>
				<div>
					<CircularProgress />
				</div>
			</Backdrop>
		</div>
	);
};

export default FullLoadingScreen;
